import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import * as moment from 'moment';

@Injectable()
export class TokenService {

  constructor(private storage: StorageService) {
  }

  public set(data) {
    data['expires'] = moment().add(data['expires_in'], 'seconds');
    return this.storage.store('tokens', data);
  }

  public clear(){
    return this.storage.clear('tokens');
  }

  // Helper functions to get authentication data
  public get(){
    return this.storage.get('tokens');
  }

  public accessToken(){
    return this.storage.get('tokens').then(tokens => {
			if (tokens != null && tokens['access_token'] != null) {
				return tokens['access_token'];
			}
			
			return "";
		});
  }

  public refreshToken(){
    return this.storage.get('tokens').then(tokens => {
      if (tokens != null && tokens['refresh_token'] != null) {
        return tokens['refresh_token'];
      }
      
      return "";
    });
  }


}
